<template>
  <MainLayout>
    <div id="contents">
      <ProdDiv />
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import ProdDiv from '@/components/ProdDiv.vue';

export default {
  name: 'ProdDivView',
  components: {
    MainLayout,
    ProdDiv,
  },
};
</script>
